import React from 'react';
import styled from 'styled-components';
import { ResellerForm } from "./ResellerForm";

const StyledDiv = styled.div`
  & div.progress-bar {
    width: 800px;
    margin: auto;
  }
  & div.main-page-section {
    width: 100%;
    background-color: #f5f5f5;
  }
  & div.form-expired {
    padding: 1rem 2rem 2rem 2rem;
  }
  & div.form-expired h1 {
    font-family: Whitney Book;
    margin-bottom: 0;
  }
  & div.form-expired h1 + div {
    width: 100vw;
  }
  & p {
    text-align: center;
    margin: auto;
  }
`

export default function FormExpired(props) {
  return (
    <StyledDiv>
      <ResellerForm
        expired
        tab="none"
        actions={{
          cancel: {
            link: "",
            label: "CANCEL",
          },
          next: {
            link: "/practice_info",
            label: "NEXT",
          },
        }}
        location={props.location}
        allowProgress={false}
      >
        <div className='form-expired'>
          <h1>Form Expired</h1>
          <div>
            <p>This form has expired and is no longer available to access.</p>
              <p>If you have questions or would like to update the information you've submitted,</p>
              <p>please contact a Platinum Advisor at (866) 553-2400 or clients@platinumperformance.com.</p>
          </div>
        </div>

    </ResellerForm>
  </StyledDiv>

  )
}
